exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-___notFound__wrapper___1TPE7{margin-top:50px}\n", ""]);

// Exports
exports.locals = {
	"wrapper": "src-components-___notFound__wrapper___1TPE7"
};